/**
 * This file needs to be extended by the tracking service that will be used to track the recaptcha events.
 * Do not use this file directly in the code.
 */

// Define the RecaptchaTracking base class
export default class RecaptchaTrackingBase {
    /**
     * RecaptchaTrackingBase constructor
     */
    constructor() {
        this.trackingService = null;
    }
    /**
     * Track recaptcha view action
     */
    view() {
        throw new Error('Method not implemented.');
    }

    /**
     * Track recaptcha verified action
     */
    verified() {
        throw new Error('Method not implemented.');
    }

    /**
     * Track recaptcha success action
     */
    success() {
        throw new Error('Method not implemented.');
    }

    /**
     * Track recaptcha failure action
     */
    failure() {
        throw new Error('Method not implemented.');
    }

    /**
     * Check if tracking service is set
     */
    checkIfTrackingServiceIsSet() {
        throw new Error('Method not implemented.');
    }
}